(ns practitest.frontend.components.account-layout.account-layout
  (:require
   [practitest.frontend.components.navigation
    :as navigation
    :refer [menu-item-header
            menu-item-element
            current-path-includes?]]
   [practitest.frontend.common.dom :as dom]
   [practitest.frontend.common.i18n :refer [get-translation]]
   [practitest.frontend.components.icons :as icons]
   [practitest.frontend.routing.backend-routes :as broutes]
   [practitest.frontend.routing.router :as router]
   [practitest.frontend.common.utils :refer [development-only]]
   [practitest.frontend.subs :as subs]
   [re-frame.core :as re-frame]
   [practitest.frontend.components.selector :as selector2]
   [practitest.frontend.components.account-layout.account-items :refer [account-setting-items]]
   [reagent.core :as reagent]))

(defn- account-selector [{:keys [target-account target-user-accounts _collapsed?]}]
  (let [selected-account (reagent/atom {:id (:id target-account) :name (:name target-account)})]
    (fn [{:keys [collapsed?]}]
      [:div.account-selector
       {:class (dom/classes-pairs :collapsed collapsed?)}
       (if collapsed?
         [:div.selected-account [:div.circle]]
         [selector2/new-select
          {:items       (map (fn [account]
                               {:id (:id account)
                                :name (:name account)})
                             target-user-accounts)
           :id          :account-selector
           :label-fn    (fn [item] (:name item))
           :selected-item-renderer (fn [item]
                                     [:div.selected-account
                                      [:div.circle]
                                      (when-not collapsed? [:span (get-in item [:value :name])])])
           :placeholder (get-translation "generic.list.placeholder" "Select Account")
           :clearable?  false
           :multi?      false
           :tags?       false
           :value       {:id (:id @selected-account)
                         :name (:name @selected-account)}
           :on-change   (fn [new-account]
                          (let [change-account-url (broutes/get-url "account/accounts#settings" {:account_id (:id new-account)})]
                            (reset! selected-account new-account)
                            (dom/navigate! change-account-url)))}])])))

(defn account-settings-panel []
  (fn [{:keys [webcomponent? target-account target-user-accounts]}]
    (let [collapsed? @(re-frame/subscribe [::navigation/project-level-menu-collapsed?])
          ;; Need here for forced redraw when route changes during client-side navigation
          ;; otherwise active element is not updated
          _current-route @(re-frame/subscribe [::router/current-route])
          user-owned-accounts (filter :is_owner target-user-accounts)
          global-fields-supported? @(re-frame/subscribe [::subs/global-fields-supported?])
          items-without-global-tab (filter #(not= (:id %) "account-settings-panel-global-fields") (account-setting-items))
          menu-items (if global-fields-supported?
                       (account-setting-items)
                       items-without-global-tab)]

      [:div.project-level-menu2
       {:class (dom/classes-pairs :collapsed collapsed?
                                  :webcomponent webcomponent?)
        :style {:flex-grow 0}}

       [account-selector {:target-user-accounts (map :account user-owned-accounts) :target-account target-account :collapsed? collapsed?}]

       [:div.project-menu-scrollable-container
        [menu-item-header {:text (get-translation "navigation.account-settings-panel.actions" "Account Settings Actions")
                           :icon icons/mux-project-settings
                           :collapsed? collapsed?}]
        [:<> (doall
              (map (fn [element]
                     (with-meta (let [uri (broutes/get-url (:route element) {:account_id (:id target-account)})
                                      active? (current-path-includes? uri)
                                      icon (:icon element)]
                                  [menu-item-element {:text (get-translation (:text-key element) (:default-text element))
                                                      :id (:id element)
                                                      :test-id (:id element)
                                                      :href uri
                                                      :active? active?
                                                      :icon (fn [] (icon {:fill-color (if active? "var(--pt-color-primary)" "var(--pt-color-black)")}))
                                                      :collapsed? collapsed?}
                                   ]) {:key (:id element)}))
                   menu-items))]]

       (development-only
        [practitest.frontend.components.navigation/developer-section collapsed?])

       [:div.close-button
        (-> {:class (dom/classes-pairs :collapsed collapsed?)
             :on-click (fn []
                         (re-frame/dispatch [::navigation/set-project-level-menu-collapsed? (not collapsed?)]))}
            (dom/add-test-id "project-menu-close-btn"))
        (when-not collapsed?
          [:span "Close"])
        [:div.arrow-close
         (if collapsed?
           [icons/mux-arrow-right]
           [icons/mux-arrow-left])]]])))

(defn account-settings-header
  [options header-bar-buttons2]
  [:div.account-settings-header
   [:a.main-logo
    {:id "account-menu-logo"
     :href (str "/accounts/" (:id (:current-account options)) "/settings")}
    [:div.icon-and-text
     [icons/account-practitest-logo]
     [:div.centered "PractiTest Account Settings"]]]
   [header-bar-buttons2 options]])
